export const RewardEvent = {
  GnbRewardHubClick: 'gnb_reward_hub_click',
  CheckInClick: 'reward_hub_checkin_click',
  RewardClaimClick: 'reward_claim_click',
  DailyCheckInTradeButtonClick: 'daily_checkin_trade_button_click',
  RewardHubBottomBannerClick: 'reward_hub_bottom_banner_click',
  RewardHubPromoUpdatesView: 'reward_hub_promo_updates_view',
  RewardHubPromoUpdatesConfirmClick: 'reward_hub_promo_updates_confirm_click',
  RewardHubPromoUpdatesCancelClick: 'reward_hub_promo_updates_cancel_click',
  RewardHubPageReferralBenefitClick: 'reward_hub_page_referral_benefit_click',
  RewardHubPageReferralTotalRewardClick: 'reward_hub_page_referral_total_reward_click',
  RewardHubPageReferralDetailClick: 'reward_hub_page_referral_detail_click',
  RewardHubPageReferralCopyCodeClick: 'reward_hub_page_referral_copy_code_click',
  RewardHubPageReferralInviteClick: 'reward_hub_page_referral_invite_click',
  RewardHubPageReferralSendReminderClick: 'reward_hub_page_referral_send_reminder_click',
} as const;

export interface RewardEventDataType {
  [RewardEvent.RewardClaimClick]: {
    task_number?: number;
    button_type: string;
    list_order: number;
    new_user: boolean;
    task_name: string;
    reward_amount?: number;
    reward_currency?: string;
    is_claim: boolean;
  };
  [RewardEvent.DailyCheckInTradeButtonClick]: {
    nth_day: number;
    nth_reward: number;
  };
  [RewardEvent.RewardHubBottomBannerClick]: {
    image_name?: string;
    event_location?: 'social_referral';
  };
}
